import { css, Paper, styled } from "@mui/material";

export const OverlayMenuBox = styled(Paper)(
    () => css`
        position: absolute;
        background: #eef0f1;
        border-radius: 35px;
        translate: -50% -50%;
        display: inline-flex;
        padding: 4px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        transition: opacity 0.1s;
    `,
);
